module.exports = __webpack_public_path__ + "media/3-1.bae547dd.wav";